import React, { forwardRef } from 'react';

import { useField } from 'formik';

import { FieldFormGroupProps } from '@shared/components/fields/field_form_group';
import { FormikFieldFormGroup } from '@shared/components/fields/formik/formik_field_form_group';
import { InputFormControlType, InputFormControlProps } from '@shared/components/fields/input_form_control';

type InputFormGroupType = InputFormControlType;
type InputFormGroupProps = InputFormControlProps & FieldFormGroupProps & { name: string; inlineLabel?: boolean };

export const FormikCheckboxFormGroup = forwardRef<InputFormGroupType, InputFormGroupProps>(
  ({ help, label, ...input }, ref) => {
    const [field, { value }, { setValue }] = useField(input.name);
    return (
      <FormikFieldFormGroup name={input.name} help={help} label={input.inlineLabel ? '' : label} id={input.id}>
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
          <input
            ref={ref}
            {...field}
            {...input}
            type="checkbox"
            onChange={(e) => setValue(e.target.checked)}
            checked={value}
            style={{ marginRight: '8px' }}
          />
          {input.inlineLabel && (
            <label
              htmlFor={input.id}
              style={{
                margin: 0,
              }}
            >
              {label}
            </label>
          )}
        </div>
      </FormikFieldFormGroup>
    );
  },
);
